// extracted by mini-css-extract-plugin
export var auto = "SplitBlock-module--auto--89eef";
export var body = "SplitBlock-module--body--8b088";
export var container = "SplitBlock-module--container--b06cd";
export var content = "SplitBlock-module--content--7e3d9";
export var hasCta = "SplitBlock-module--hasCta--91f4f";
export var hasImageOffset = "SplitBlock-module--hasImageOffset--1fe57";
export var hasSpacer = "SplitBlock-module--hasSpacer--7e891";
export var hasSpacerLg = "SplitBlock-module--hasSpacerLg--3b5c8";
export var heading = "SplitBlock-module--heading--5bc5c";
export var image = "SplitBlock-module--image--5538b";
export var imageContainer = "SplitBlock-module--imageContainer--c660b";
export var inner = "SplitBlock-module--inner--3684d";
export var layoutImageSide = "SplitBlock-module--layoutImageSide--c7091";
export var layoutImageTop = "SplitBlock-module--layoutImageTop--cc368";
export var layoutIntro = "SplitBlock-module--layoutIntro--00a6a";
export var left = "SplitBlock-module--left--eec63";
export var navy = "SplitBlock-module--navy--e9eca";
export var plum = "SplitBlock-module--plum--d1e73";
export var right = "SplitBlock-module--right--aa299";
export var tan = "SplitBlock-module--tan--2d3ad";
export var white = "SplitBlock-module--white--ed8de";